import React from 'react';
import { Table, Typography } from 'antd';

const { Text } = Typography;

const TableBlock = ({ title, columns, rows }) => (
  <div className="agent-table-block">
    {title && <Text strong>{title}</Text>}
    <Table
      dataSource={rows}
      columns={columns.map((col) => ({
        title: col,
        dataIndex: col,
        key: col,
        width: 150,
        render: (value) => (typeof value === 'number' ? value.toFixed(2) : value),
      }))}
      rowKey={(record, index) => index}
      pagination={false}
      scroll={{ x: true, y: 320 }}
      size="small"
      className="compact-table"
      style={{ marginTop: 8 }}
    />
  </div>
);

export default TableBlock;
